import { LucideIcon } from "lucide-react";

interface PaymentInstructionProps {
  Icon: LucideIcon;
  text: string;
}

const PaymentInstruction = ({ Icon, text }: PaymentInstructionProps) => {
  return (
    <div className="flex items-center gap-3">
      <Icon strokeWidth={1.5} size={36} />

      <p>{text}</p>
    </div>
  );
}

export default PaymentInstruction;
